export default function Rules() {
  return (
    <section id="regulamento" className="py-16 sm:py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Regras e Regulamento
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-800 p-8 sm:p-12 rounded-xl border-2 border-orange-500">
            <div className="flex items-center justify-center mb-8">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
            </div>

            <h3 className="text-2xl sm:text-3xl font-bold text-center mb-6">
              Regulamento Oficial Completo
            </h3>

            <p className="text-base sm:text-lg text-gray-300 text-center mb-8 leading-relaxed">
              O Regulamento Oficial contém todas as informações detalhadas sobre:
            </p>

            <ul className="space-y-4 mb-10">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <span className="text-base sm:text-lg text-gray-300">Sistema de pontuação completo do campeonato</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <span className="text-base sm:text-lg text-gray-300">Traçados específicos de cada pista</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <span className="text-base sm:text-lg text-gray-300">Regras detalhadas de conduta e penalidades</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <span className="text-base sm:text-lg text-gray-300">Procedimentos de protesto e recursos</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <span className="text-base sm:text-lg text-gray-300">Informações sobre premiações e valores</span>
              </li>
            </ul>

            <div className="bg-orange-500/10 border-l-4 border-orange-500 p-6 rounded-lg mb-8">
              <p className="text-base text-gray-300">
                <strong className="text-orange-500">Importante:</strong> Entre no grupo oficial do campeonato para acessar o Regulamento Oficial completo e não perder nenhuma atualização importante.
              </p>
            </div>

            <div className="text-center">
              <a 
                href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 text-base sm:text-lg whitespace-nowrap cursor-pointer"
              >
                Entrar no grupo oficial
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
